import { Tag } from "@components/";

export const fields = [
  "Tipo",
  "ID da Solicitação",
  "Estabelecimento",
  "Tipo de envio",
  "Pedido interno",
  "Classificação da troca",
  "Avaliação de crédito",
  "Plataforma",
  "Retira",
  "Número de parcelas",
  "Observações",
  "Evidências do motivo",
];

export const values = [
  <Tag>Troca</Tag>,
  <a href="#" className="text-blue-600 underline">
    34793800
  </a>,
  "Estabelecimento 1",
  "Tipo 1",
  "Lorem Ipsum",
  "Classificação 1",
  "Sim",
  "Lorem Ipsum",
  "Lorem Ipsum",
  "3",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nunc ut.",
];

export const classificacaoTroca = [
  {
    label: "Acordo Judicial / Procon",
    value: "pedido_classificacao_da_troca_acordo_judicial_/_procon",
  },
  {
    label: "Aguardando retirada",
    value: "pedido_classificacao_da_troca_aguardando_retirada",
  },
  {
    label: "Alçada Reclame Aqui",
    value: "pedido_classificacao_da_troca_alçada_reclame_aqui",
  },
  {
    label: "Análise engenharia (sinistro/produto para análise)",
    value: "pedido_classificacao_da_troca_análise_engenharia__sinistro/produto_para_análise_",
  },
  {
    label: "Atraso de entrega",
    value: "pedido_classificacao_da_troca_atraso_de_entrega",
  },
  { 
    label: "Cliente ausente", 
    value: "pedido_classificacao_da_troca_cliente_ausente" 
  },
  {
    label: "Defeito estético",
    value: "pedido_classificacao_da_troca_defeito_estético",
  },
  {
    label: "Defeito funcional",
    value: "pedido_classificacao_da_troca_defeito_funcional",
  },
  {
    label: "Endereço não localizado",
    value: "pedido_classificacao_da_troca_endereço_não_localizado",
  },
  {
    label: "Entrega divergente",
    value: "pedido_classificacao_da_troca_entrega_divergente",
  },
  { 
    label: "Envio Brinde", 
    value: "pedido_classificacao_da_troca_envio_brinde" 
  },
  { 
    label: "Erro de anúncio", 
    value: "pedido_classificacao_da_troca_erro_de_anúncio" 
  },
  {
    label: "Extravio / Sinistro",
    value: "pedido_classificacao_da_troca_extravio_/_sinistro",
  },
  {
    label: "Falha da logistica",
    value: "pedido_classificacao_da_troca_falha_da_logistica",
  },
  {
    label: "Falha do posto autorizado",
    value: "pedido_classificacao_da_troca_falha_do_posto_autorizado",
  },
  {
    label: "Faltando acessórios/ danificado",
    value: "pedido_classificacao_da_troca_faltando_acessórios/_danificado",
  },
  { 
    label: "Não integrado", 
    value: "pedido_classificacao_da_troca_não_integrado" 
  },
  {
    label: "Pedido entregue parcial",
    value: "pedido_classificacao_da_troca_pedido_entregue_parcial",
  },
  {
    label: "Produto de Troca Apresentou Defeito",
    value: "pedido_classificacao_da_troca_produto_de_troca_apresentou_defeito",
  },
  {
    label: "Produto enviado em cortesia",
    value: "pedido_classificacao_da_troca_produto_enviado_em_cortesia",
  },
  { 
    label: "Reincidência", 
    value: "pedido_classificacao_da_troca_reincidência" 
  },
  {
    label: "Sem motivo técnico / Reclamação",
    value: "pedido_classificacao_da_troca_sem_motivo_técnico_/_reclamação",
  },
  { 
    label: "Tutela", 
    value: "pedido_classificacao_da_troca_tutela" 
  },
  { 
    label: "Voltagem errada", 
    value: "pedido_classificacao_da_troca_voltagem_errada" 
  },
];

export const plataformas = [
  { label: "AJ Place", value: "pedido_plataforma_aj_place" },
  { label: "Amazon", value: "pedido_plataforma_amazon" },
  { label: "Angeloni", value: "pedido_plataforma_angeloni" },
  { label: "B2W", value: "pedido_plataforma_b2w" },
  { label: "Balaroti", value: "pedido_plataforma_balaroti" },
  { label: "Banco Inter", value: "pedido_plataforma_banco_inter" },
  { label: "Best Off", value: "pedido_plataforma_best_off" },
  { label: "Bradesco", value: "pedido_plataforma_bradesco" },
  { label: "Britânia", value: "pedido_plataforma_britânia" },
  { label: "Britânia em Casa", value: "pedido_plataforma_britânia_em_casa" },
  { label: "C&A", value: "pedido_plataforma_c_a" },
  { label: "Camicado", value: "pedido_plataforma_camicado" },
  { label: "Canal Rural", value: "pedido_plataforma_canal_rural" },
  { label: "Carrefour", value: "pedido_plataforma_carrefour" },
  { label: "Casa e Vídeo", value: "pedido_plataforma_casa_e_vídeo" },
  { label: "Cassol", value: "pedido_plataforma_cassol" },
  { label: "Clube de compras", value: "pedido_plataforma_clube_de_compras" },
  { label: "Cnova", value: "pedido_plataforma_cnova" },
  { label: "Colombo", value: "pedido_plataforma_colombo" },
  { label: "Compra Certa", value: "pedido_plataforma_compra_certa" },
  { label: "Coopera", value: "pedido_plataforma_coopera" },
  { label: "Droga Raia", value: "pedido_plataforma_droga_raia" },
  { label: "Facebook", value: "pedido_plataforma_facebook" },
  { label: "Fast Shop", value: "pedido_plataforma_fast_shop" },
  { label: "Google Shopping", value: "pedido_plataforma_google_shopping" },
  {
    label: "Grand Plaza Shopping",
    value: "pedido_plataforma_grand_plaza_shop",
  },
  { label: "Grandes Ofertas", value: "pedido_plataforma_grandes_ofertas" },
  { label: "Império", value: "pedido_plataforma_império" },
  { label: "Infoar", value: "pedido_plataforma_infoar" },
  { label: "Kabum", value: "pedido_plataforma_kabum" },
  { label: "Le Biscuit", value: "pedido_plataforma_le_biscuit" },
  { label: "Leroy Merlin", value: "pedido_plataforma_leroy_merlin" },
  { label: "Livelo", value: "pedido_plataforma_livelo" },
  { label: "Madeira Madeira", value: "pedido_plataforma_madeira_madeira" },
  { label: "Magazine Luiza", value: "pedido_plataforma_magazine_luiza" },
  {
    label: "Magazine Luiza Prime",
    value: "pedido_plataforma_magazine_luiza_pri",
  },
  { label: "Max Points", value: "pedido_plataforma_max_points" },
  { label: "Mercado Livre", value: "pedido_plataforma_mercado_livre" },
  { label: "Muffato", value: "pedido_plataforma_muffato" },
  { label: "Na prateleira", value: "pedido_plataforma_na_prateleira" },
  { label: "NEXT", value: "pedido_plataforma_next" },
  { label: "Novo mundo", value: "pedido_plataforma_novo_mundo" },
  { label: "On Stores", value: "pedido_plataforma_on_stores" },
  { label: "Panvel", value: "pedido_plataforma_panvel" },
  { label: "Pão de Açúcar", value: "pedido_plataforma_pão_de_açúcar" },
  { label: "Pernambucanas", value: "pedido_plataforma_pernambucanas" },
  { label: "Philco", value: "pedido_plataforma_philco" },
  { label: "Philco Club", value: "pedido_plataforma_philco_club" },
  { label: "PicPay", value: "pedido_plataforma_picpay" },
  { label: "Prumo", value: "pedido_plataforma_prumo" },
  { label: "Riachuelo", value: "pedido_plataforma_riachuelo" },
  { label: "Rede Massa", value: "pedido_plataforma_rede_massa" },
  { label: "RENNER", value: "pedido_plataforma_renner" },
  { label: "Senff", value: "pedido_plataforma_senff" },
  { label: "Shopee", value: "pedido_plataforma_shopee" },
  { label: "Shopping Cidade SP", value: "pedido_plataforma_shopping_cidade_s" },
  { label: "Shopping D", value: "pedido_plataforma_shopping_d" },
  {
    label: "Shopping Metropolitano Barra",
    value: "pedido_plataforma_shopping_metropo",
  },
  { label: "Sicredi", value: "pedido_plataforma_sicredi" },
  { label: "Sipolatti", value: "pedido_plataforma_sipolatti" },
  { label: "Tunder", value: "pedido_plataforma_tunder" },
  { label: "Vem pra cá", value: "pedido_plataforma_vem_pra_cá" },
  { label: "Zoom", value: "pedido_plataforma_zoom" },
];

export const retiraValues = [
  { label: "AG - Joinville", value: "ag_joinville" },
  { label: "CD - Joinville", value: "cd_joinville" },
  { label: "Prime - Joinville", value: "prime_joinville" },
  { label: "Matriz - Curitiba", value: "matriz_curitiba" },
  { label: "Marechal - Curitiba", value: "marechal_curitiba" },
];

export const statusIntegracao = [
  { label: "Análise", value: "pedido_status_da_integracao_análise" },
  { label: "Pendente", value: "pedido_status_da_integracao_pendente" },
  { label: "Integrado", value: "pedido_status_da_integracao_integrado" },
  { label: "Erro", value: "pedido_status_da_integracao_erro" },
  { label: "Cancelado", value: "pedido_status_da_integracao_cancelado" },
  { label: "Não integrado", value: "pedido_status_da_integracao_não_inte" },
  { label: "Reprovado", value: "pedido_status_da_integracao_reprovado" },
];
